import { el } from 'redom';

import { getProductDefaultValues } from './utilities';

import ProductViewer from './viewer';

class Product {

  constructor(configuration) {

    this.productId = configuration.productId;
    this.onChange = configuration.onChange;

    this.viewer = new ProductViewer({
      productId: this.productId,
      onNotFound: this.handleProductNotFound.bind(this)
    });

    this.el = el('.product-main', [
      this.tryRenderProduct()
    ]);

  }

  tryRenderProduct() {

    if (this.productId === null) {
      return;
    }

    return this.viewer;

  }

  handleProductNotFound() {

    this.productId = null;

    this.handleEditRequest(getProductDefaultValues());

    this.onChange({ productId: this.productId, product: void 0 });

  }

}

export default Product;